module.exports = __webpack_public_path__ + "img/profile.d5d41666.svg";